<template>
  <div class="app-shell">
    <AppHeader class="app-header" :tenant="tenant" @customers="customers = true" />

    <!-- Keyed by path so a new customer or page remounts the view; the query is
         left out so pages keeping filters in the URL are not remounted. -->
    <main class="app-scroll">
      <router-view :key="route.path" />
    </main>

    <AppFooter class="d-none d-lg-flex" />
    <AppNav class="app-nav-bottom d-lg-none" :stacked="true" />

    <TenantPanel :show="customers" @close="customers = false" @changed="load" />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { useRoute } from 'vue-router'
import AppHeader from '@/components/AppHeader/index.vue'
import AppNav from '@/components/AppNav.vue'
import AppFooter from '@/components/AppFooter.vue'
import TenantPanel from '@/components/tenant/index.vue'
import { get } from '@/libraries/tenant'
import { ALL, tenantOf } from '@/libraries/route'
import { factory as factoryTenant, type define as Tenant } from '@/components/tenant/interfaces'

export default defineComponent({
  name: 'DefaultLayout',
  components: { AppHeader, AppNav, AppFooter, TenantPanel },
  setup() {
    return { route: useRoute() }
  },
  data() {
    const tenant: Tenant = factoryTenant()
    return {
      customers: false,
      tenant,
    }
  },
  computed: {
    key(): string {
      return tenantOf(this.route)
    },
  },
  watch: {
    key: 'load',
  },
  /* Loaded from mounted(), not by an immediate watcher, so requests leave in mount order. */
  mounted() {
    this.load()
  },
  methods: {
    /* Loaded here, not in the header: the header is never remounted and the
       panel that changes the customer lives here. */
    load(): void {
      const key = this.key
      if (key === ALL) {
        this.tenant = factoryTenant()
        document.title = 'Supia'
        return
      }
      get(key).then((response) => {
        if (!response) return
        this.tenant = response
        document.title = response.name.toUpperCase()
      })
    },
  },
})
</script>
